module.exports = "<wow-card-list ng-if=\"!specialsGroupsService.selectedGroup.Url\">\r\n    <wow-specials-group-products></wow-specials-group-products>\r\n</wow-card-list>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/specials/specials-group-display-template.html
 ** module id = 1028
 ** module chunks = 1
 **/